import { createSelector } from 'reselect';
import { EMAILS_DOMAIN } from './constants';
import { initialState } from './reducer';
const selectEmailHistoryDomain = state => state[EMAILS_DOMAIN] || initialState;

export const selectEmailHistory = () =>
  createSelector(
    selectEmailHistoryDomain,
    d => d.emails,
  );

export const selectEmailHistoryCount = () =>
  createSelector(
    selectEmailHistoryDomain,
    d => d.emailsCount,
  );

export const selectEmailHistoryFilter = () =>
  createSelector(
    selectEmailHistoryDomain,
    d => d.filter,
  );
